<template>
    <div style="margin-top: 10px;">
        <v-container>
            <v-toolbar style="border-radius: 10px;">
                <v-toolbar-title style="padding: 10px; font-weight: bold;">{{ $t('Synoptics.title') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <multipla-escolha :items="linhas" ref="linhasSelect" text="nome_linha" value="id_linha"
                    :label="$tc('line.self', 2)" can-toggle-all v-bind:selected-items.sync="linhasSelecionadas"
                    style="padding: 10px; margin-top: 20px;"></multipla-escolha>
            </v-toolbar>
        </v-container>

        <div v-for="linha in linhasSinotico" :key="`${linha.id_linha}-${linha.id_sentido}`" style="padding: 10px;">
            <SinoticoParadas
                :paradas="paradas.filter(parada => parada.id_linha === linha.id_linha && (parada.id_sentido === 1))"
                :veiculos="veiculosSinotico.filter(veiculo => veiculo.id_linha === linha.id_linha && veiculo.sentido === 0)"
                :vertical="vertical" :titulo="`${linha.nome_linha} - ${$t('painel.direction.outbound')}`"
                :pontoInicial="paradas.find(parada => parada.id_tipo_cerca === 2 && parada.id_linha === linha.id_linha)"
                :pontoFinal="paradas.find(parada => parada.id_tipo_cerca === 3 && parada.id_linha === linha.id_linha)"
                corDestaque="#008000" style="margin-bottom: 5px;" />
            <SinoticoParadas
                :paradas="paradas.filter(parada => parada.id_linha === linha.id_linha && (parada.id_sentido === 2))"
                :veiculos="veiculosSinotico.filter(veiculo => veiculo.id_linha === linha.id_linha && veiculo.sentido === 1)"
                :vertical="vertical" :titulo="`${linha.nome_linha} - ${$t('painel.direction.inbound')}`"
                :pontoInicial="paradas.find(parada => parada.id_tipo_cerca === 3 && parada.id_linha === linha.id_linha)"
                :pontoFinal="paradas.find(parada => parada.id_tipo_cerca === 2 && parada.id_linha === linha.id_linha)"
                corDestaque="#FF5722" style="margin-bottom: 5px;" />
        </div>
    </div>
</template>

<script>
import SinoticoParadas from './SinoticoParadas.vue'
import MultiplaEscolha from './Selects/MultiplaEscolha.vue'
import apiController from '@/utils/apiController'
import EventBus from '@/utils/eventBus'

export default {
    name: 'DashSinotico',
    components: {
        SinoticoParadas,
        MultiplaEscolha
    },
    props: {
        veiculos: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    data() {
        return {
            user: null,
            token: null,
            veiculosSinotico: [],
            paradas: [],
            linhas: [],
            linhasSelecionadas: [],
            vertical: false,
            timeout: null
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    beforeDestroy() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
        },
        veiculos: {
            handler(newVeiculos) {
                if (newVeiculos && newVeiculos.length > 0) {
                    this.veiculosSinotico = newVeiculos.filter(veiculo => veiculo.id_viagem !== null);
                }
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        linhasSinotico() {
            return this.linhas.filter(linha => this.linhasSelecionadas.includes(linha.id_linha));
        }
    },
    methods: {
        async initialize() {
            await this.populaLinhas();
            await this.populaParadas();
            this.populaVeiculos();
        },
        async populaLinhas() {
            try {
                const response = await apiController.request(apiController.endpoints.getLinhasoperacao, {
                    silent: true,
                });
                if (response.data?.erro) {
                    this.linhas = [];
                    EventBus.$emit('show-alert', {
                        mensagem: response.data.mensagem || this.$t('Synoptics.errors.loadLines'),
                        tipo: 'error'
                    });
                    return;
                }

                if (!Array.isArray(response.data)) {
                    this.linhas = [];
                    EventBus.$emit('show-alert', {
                        mensagem: this.$t('Synoptics.errors.invalidResponse'),
                        tipo: 'warning'
                    });
                    return;
                }

                this.linhas = response.data;
                this.linhas.sort((a, b) => {
                    let cod_a = parseInt(a.cod_linha.match(/\d+/)[0]);
                    let cod_b = parseInt(b.cod_linha.match(/\d+/)[0]);
                    
                    if (cod_a === cod_b) {
                        let sub_a = a.cod_linha.match(/[^\d]+/);
                        let sub_b = b.cod_linha.match(/[^\d]+/);
                        if (sub_a && sub_b) {
                            return sub_a[0].localeCompare(sub_b[0]);
                        }
                        return sub_a ? 1 : -1;
                    } else {
                        return cod_a - cod_b;
                    }
                });
            } catch (error) {
                this.linhas = [];
                EventBus.$emit('show-error', { error });
            }
        },
        async populaParadas() {
            try {
                const response = await apiController.request(apiController.endpoints.getCercasporlinhacomvigencia, {
                    data: this.linhas.map(linha => linha.id_linha),
                    silent: true,
                });

                // Check if response is valid
                if (response.data && response.data.erro) {
                    this.paradas = [];
                    EventBus.$emit('show-alert', {
                        mensagem: response.data.mensagem || this.$t('Synoptics.errors.loadFences'),
                        tipo: 'error'
                    });
                    return;
                }
                
                if (!Array.isArray(response.data)) {
                    this.paradas = [];
                    EventBus.$emit('show-alert', {
                        mensagem: this.$t('Synoptics.errors.invalidFencesResponse'),
                        tipo: 'warning'
                    });
                    return;
                }
                
                const alternativeCercas = response.data.filter((c) => c.is_vigencia === 1);
                if (alternativeCercas.length > 0) {
                    EventBus.$emit('show-alert', {
                        mensagem: this.$t('Synoptics.info.alternativeFences', { count: alternativeCercas.length }),
                        tipo: 'info',
                        duracao: 4000
                    });
                }
                
                this.paradas = response.data.filter(parada => parada.id_tipo_cerca === 2 || parada.id_tipo_cerca === 3 || parada.id_tipo_cerca === 5);
            } catch (error) {
                this.paradas = [];
                EventBus.$emit('show-error', { error });
            }
        },
        async populaVeiculos() {
            // Se não há veículos via props, busca da API
            if (!this.veiculos || this.veiculos.length === 0) {
                await this.getVeiculosEmViagem();
            }
            // Se há veículos via props, o watcher já cuida da atualização
        },
        async getVeiculosEmViagem() {
            try {
                const response = await apiController.request(apiController.endpoints.getVeiculosemviagem, {
                    silent: true,
                });
                if (response.data?.erro) {
                    this.veiculosSinotico = [];
                    EventBus.$emit('show-alert', {
                        mensagem: response.data.mensagem || this.$t('Synoptics.errors.loadVehicles'),
                        tipo: 'error'
                    });
                } else if (Array.isArray(response.data)) {
                    this.veiculosSinotico = response.data.filter(veiculo => veiculo.id_viagem !== null);
                } else {
                    this.veiculosSinotico = [];
                    EventBus.$emit('show-alert', {
                        mensagem: this.$t('Synoptics.errors.invalidVehiclesResponse'),
                        tipo: 'warning'
                    });
                }
            } catch (error) {
                this.veiculosSinotico = [];
                EventBus.$emit('show-error', { error });
            }
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(() => {
                this.getVeiculosEmViagem();
            }, 60000);
        },
    }
}
</script>

<style scoped></style>